import React, { useState, useEffect, useRef } from 'react';
import './ProjectDetails.css';
import HOASection from './HOASection';
import SummaryModal from './SummaryModal';

const ProjectDetails = ({locationName, coords, area, setLocationName}) => {
// Dropdown States
  const [isOpen, setIsOpen] = useState(false);
  const [selectedType, setSelectedType] = useState('land+snow');
  const dropdownRef = useRef(null);

  // Sitemap & Instructions States
  const [uploadedFile, setUploadedFile] = useState(null); 
  const [instructions, setInstructions] = useState([
    "Prioritize clearing the North entrance first.",
    "Do not use salt on the decorative stone walkways."
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false); // Separate state for modal
  const [newInstruction, setNewInstruction] = useState("");

  const reportFeatures = {
    'land+snow': ['Lawn', 'Sidewalk', 'ParkingSpot', 'Tree', 'SoftEdge', 'GravelBed', 'Pavement', 'Driveway', 'Hedge', 'HardEdge', 'MulchBed', 'DriveLanes', 'Line Trim'],
    'softscapes-only': ['Lawn', 'Tree', 'Soft Edge', 'Gravel Bed', 'Hedge', 'Hard Edge', 'Mulch Bed', 'Line trim'],
    'snow-only': ['Sidewalk', 'ParkingSpot', 'SoftEdge', 'Pavement', 'Driveway', 'HardEdge', 'DriveLanes', 'Line trim'],
    'lawn-report': ['Lawn'],
    'paving': ['Parking stalls stripes', 'Stop bar stripes', 'Handicap parking stall count', 'Asphalt', 'Directional arrows count', 'Linear Curb Strip', 'Cross hatching stripes', 'Other stripes', 'Regular parking stall count', 'Concrete', 'Surface Curb Strips'],
    'striping': ['Parking stalls stripes', 'Stop bar stripes', 'Handicap parking stall count', 'Surface Curb Strips', 'Cross hatching stripes', 'Other stripes', 'Regular parking stall count', 'Linear Curb Strip'],
    'land+snow-equip': ['60-inch Mower', '48-inch Mower', '36-inch Mower', 'Sidewalk', 'ParkingSpot', 'Tree', 'SoftEdge', 'GravelBed', 'Pavement', 'Driveway', 'Hedge', 'HardEdge', 'MulchBed', 'DriveLanes', 'Line trim'],
    'land+snow-freq': ['Rough Mow', 'Primary Mow', 'Secondary Mow', 'Sidewalk', 'ParkingSpot', 'Tree', 'SoftEdge', 'GravelBed', 'Pavement', 'Driveway', 'Hedge', 'HardEdge', 'MulchBed', 'DriveLanes', 'Line trim'],
    'softscapes-equip': ['60-inch Mower', '48-inch Mower', '36-inch Mower', 'Tree', 'Soft Edge', 'Gravel Bed', 'Hedge', 'Hard Edge', 'Mulch Bed', 'Line trim'],
    'softscapes-freq': ['Rough Mow', 'Primary Mow', 'Secondary Mow', 'Tree', 'Soft Edge', 'Gravel Bed', 'Hedge', 'Hard Edge', 'Mulch Bed', 'Line trim']
  };

  const reportOptions = [
    { value: 'land+snow', name: 'Land + Snow', desc: 'Complete analysis with both' },
    { value: 'softscapes-only', name: 'Softscapes only', desc: 'Focus on softscape features' },
    { value: 'snow-only', name: 'Snow Only', desc: 'Snow removal analysis' },
    { value: 'lawn-report', name: 'Lawn Report', desc: 'Detailed lawn analysis' },
    { value: 'paving', name: 'Paving', desc: 'Paving analysis' },
    { value: 'striping', name: 'Striping', desc: 'Parking striping' },
    { value: 'land+snow-equip', name: 'Land + Snow - Equip', desc: 'Equipment-based analysis' },
    { value: 'land+snow-freq', name: 'Land + Snow - Freq', desc: 'Frequency-based analysis' },
  ];

  const currentSelection = reportOptions.find(opt => opt.value === selectedType) || reportOptions[0];

  const handleSaveInstruction = () => {
    if (newInstruction.trim()) {
      setInstructions([...instructions, newInstruction]);
      setNewInstruction("");
      setIsModalOpen(false);
    }
  };


  // 1. Add this state at the top of your ProjectDetails component
const [isMinutes, setIsMinutes] = useState(false);

// 2. Add this helper function inside the component
const getFormattedTime = () => {
  const minRange = 4;
  const maxRange = 5;

  if (isMinutes) {
    // Conversion: Hours * 60
    return `≈ ${minRange * 60}-${maxRange * 60} Mins`;
  }
  return `≈ ${minRange}-${maxRange} Hours`;
};



// Add this state at the top of ProjectDetails component
const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);



// new code and functions 
// Add this state
const [isAcres, setIsAcres] = useState(false);

// Add this helper
const getDisplayArea = () => {
  // Ensure 'area' is treated as a number
  const numericArea = parseFloat(area) || 0;

  if (isAcres) {
    // Convert Sqft to Acres (43,560 sqft = 1 acre)
    return (numericArea / 43560).toFixed(2);
  }

  // Returns Sqft formatted to 2 decimal places with thousands separators
  return numericArea.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};



const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
const [tempAddress, setTempAddress] = useState(locationName);

// Sync temp address whenever locationName changes from the map search
useEffect(() => {
  setTempAddress(locationName);
}, [locationName]);

const handleAddressUpdate = () => {
  // Update the parent state (locationName)
  // Note: Ensure locationName is a state in Home.js and passed down
  // if you want it to reflect everywhere.
  setLocationName(tempAddress); 
  setIsAddressModalOpen(false);
};



  return (
    <div className="clean-premium-sidebar">
      {/* HEADER SECTION */}
      <div className="panel-header-modern mb-3">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="panel-title-group">
            <i className="fa-solid fa-clipboard-list panel-icon-main"></i>
            <h5 className="m-0 fw-bold">Project Details</h5>
          </div>
          <div className="premium-status-pill">Draft</div>
        </div>
        
        {/* PROPERTY ID STRIP - Correctly positioned below title */}
        <div className="property-id-strip">
          <label className="id-label">Property ID</label>
          <div className="id-value-display">MES-PR-HC9U1SDS0ODUQ08QQM</div>
        </div>
      </div>

      {/* PRIMARY INFO CARD (SITE METRICS) */}
      <div className="detail-card-premium mb-3">
        <div className="card-header-sub">
          <div className="d-flex align-items-center gap-2">
            <i className="fa-solid fa-circle-info text-primary"></i>
            <span className="fw-bold text-dark">Project Information</span>
          </div>
        </div>

        {/* Address Row */}
        <div className="detail-row-modern">
  <div className="detail-label-group">
    <i className="fa-solid fa-map-marker-alt"></i>
    <span>Address</span>
  </div>
  <div className="detail-value-group">
    <span className="address-truncate">{locationName}</span>
    <button 
      className="edit-btn-inline" 
      onClick={() => setIsAddressModalOpen(true)}
    >
      <i className="fa-solid fa-pen-to-square"></i>
    </button>
  </div>
</div>


{/* ADDRESS EDIT MODAL */}
{isAddressModalOpen && (
  <div className="instruction-modal-overlay">
    <div className="instruction-modal-content">
      <div className="modal-header">
        <div className="modal-title">
          <i className="fa-solid fa-location-dot me-2"></i> Edit Address
        </div>
        <button className="close-x" onClick={() => setIsAddressModalOpen(false)}>&times;</button>
      </div>
      <div className="modal-body">
        <label className="text-muted small mb-2">Display Address</label>
        <textarea 
          className="instruction-textarea" 
          rows="3"
          value={tempAddress}
          onChange={(e) => setTempAddress(e.target.value)}
        ></textarea>
      </div>
      <div className="modal-footer">
        <button className="btn-cancel" onClick={() => setIsAddressModalOpen(false)}>Cancel</button>
        <button className="btn-save" onClick={handleAddressUpdate}>Update Address</button>
      </div>
    </div>
  </div>
)}



        {/* Lot Area Row */}
        <div className="detail-row-modern">
          <div className="detail-label-group">
            <i className="fa-solid fa-expand-arrows-alt"></i>
            <span>Lot Area</span>
          </div>
          <div className="area-pill">
  <span className="fw-bold">{getDisplayArea()}</span>
  <small className="ms-1">{isAcres ? 'Acres' : 'Sqft'}</small>
  <button 
    className="unit-toggle" 
    onClick={() => setIsAcres(!isAcres)}
    type="button" // Prevents accidental form submission
  >
    <i className="fa-solid fa-arrows-rotate"></i>
  </button>
</div>
        </div>

        {/* Created Date Row */}
        <div className="detail-row-modern no-border">
          <div className="detail-label-group">
            <i className="fa-regular fa-calendar-check"></i>
            <span>Created</span>
          </div>
          <div className="detail-value-text">Nov 15 2023</div>
        </div>
      </div>



      {/* Report Type */}
<div className="detail-card">
        {/* <div className="card-header">
          <div className="card-title">
            <i className="fas fa-file-alt card-icon"></i>
            Report Type
          </div>
        </div> */}

        <div className="d-flex align-items-center gap-2">
            <i className="fas fa-file-alt card-icon"></i>
            <span className="fw-bold text-dark"> Report Type</span>
          </div>



        <div className="dropdown-container" ref={dropdownRef}>
          <div className="dropdown-header" onClick={() => setIsOpen(!isOpen)}>
            <div className="dropdown-selected">
              <div className="dropdown-selected-name">{currentSelection.name}</div>
              <div className="dropdown-selected-desc">{currentSelection.desc}</div>
            </div>
            <div className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>
              <i className="fas fa-chevron-down"></i>
            </div>
          </div>

          {isOpen && (
            <div className="dropdown-list">
              {reportOptions.map((option) => (
                <div 
                  key={option.value} 
                  className="dropdown-item" 
                  onClick={() => {
                    setSelectedType(option.value);
                    setIsOpen(false);
                  }}
                >
                  <div className="dropdown-item-name">{option.name}</div>
                  <div className="dropdown-item-desc">{option.desc}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Features Section - Always show for selected type */}
        <div className="features-section">
          <div className="features-title">
            <i className="fas fa-list-check"></i>
            Features Covered
          </div>
          <div className="features-list">
            {reportFeatures[selectedType]?.map((feature, index) => (
              <div key={index} className="feature-static">
                {feature}
              </div>
            ))}
          </div>
        </div>
      </div>



{/* SITEMAP & INSTRUCTIONS SECTION */}
<div className="sitemap-instructions-container mb-3">
 

<div className="d-flex align-items-center gap-2 mb-2">
           <i className="fas fa-paperclip me-2 card-icon-blue"></i>
            <span className="fw-bold text-dark"> Sitemap & Instructions</span>
          </div>


  <div className="action-cards-row">
    {/* Upload Sitemap Card */}
    <label className="action-card" htmlFor="sitemap-upload">
      <input 
        type="file" 
        id="sitemap-upload" 
        hidden 
        accept=".jpg,.png,.pdf" 
        onChange={(e) => {
            if(e.target.files[0]) {
                setUploadedFile(e.target.files[0].name);
                // Handle your upload logic here
            }
        }}
      />
      <div className="icon-wrapper upload-bg">
        <i className="fas fa-cloud-upload-alt"></i>
      </div>
      <h3>Upload Sitemap</h3>
      <p>Price and TAT updated per sitemap. JPG, PNG, PDF</p>
    </label>

    {/* Add Instruction Card */}
    <div className="action-card" onClick={() => setIsModalOpen(true)}>
      <div className="icon-wrapper edit-bg">
        <i className="fas fa-edit"></i>
      </div>
      <h3>Add Instruction</h3>
      <p>Provide specific instructions to follow</p>
    </div>
  </div>
 
</div>

{/* INSTRUCTION MODAL */}
{isModalOpen && (
  <div className="instruction-modal-overlay">
    <div className="instruction-modal-content">
      <div className="modal-header">
        <div className="modal-title">
          <i className="fas fa-edit me-2"></i> Add Instruction
        </div>
        <button className="close-x" onClick={() => setIsModalOpen(false)}>&times;</button>
      </div>
      <div className="modal-body">
        <textarea 
          className="instruction-textarea" 
          placeholder="Enter your specific instructions here..."
          value={newInstruction}
          onChange={(e) => setNewInstruction(e.target.value)}
        ></textarea>
      </div>
      <div className="modal-footer">
        <button className="btn-cancel" onClick={() => setIsModalOpen(false)}>Cancel</button>
        <button className="btn-save" onClick={handleSaveInstruction}>Save Instruction</button>
      </div>
    </div>
  </div>
)}




<HOASection />



{/* Project estimate  */}
{/* PROJECT ESTIMATE SECTION */}
<div className="estimate-card-premium mt-3">
  <div className="d-flex align-items-center gap-2 mb-3">
    <i className="fa-solid fa-calculator text-purple-main"></i>
    <span className="fw-bold text-dark">Project Estimate</span>
  </div>

  {/* Time Required Row */}
  <div className="estimate-row">
  <span className="estimate-label">TIME REQUIRED</span>
  <div className="time-value-group">
    {/* Call the formatting function here */}
    <span className="time-highlight">{getFormattedTime()}</span>
    
    {/* Added onClick to toggle the unit */}
    <button 
      className="sync-btn" 
      onClick={() => setIsMinutes(!isMinutes)}
      title="Toggle Hours/Minutes"
    >
      <i className="fas fa-exchange-alt"></i>
    </button>
  </div>
</div>

  <div className="divider-dashed"></div>

  {/* Estimated Cost Row */}
  <div className="estimate-row align-items-center mb-4">
    <span className="estimate-label">ESTIMATED COST</span>
    <span className="cost-value">$321.32</span>
  </div>

  {/* Discount Code Box */}
  <div className="discount-apply-container">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <span className="discount-title">Apply Discount Code</span>
      <span className="promo-badge">SUMMER20</span>
    </div>
    <div className="discount-input-group">
      <input type="text" placeholder="Enter code" className="promo-input" />
      <button className="promo-apply-btn">Apply</button>
    </div>
  </div>
</div>

{/* FOOTER ACTION BUTTONS */}
<div className="footer-actions-container mt-4"> 


<button className="btn-action-main btn-generate" onClick={() => setIsSummaryModalOpen(true)}>
  <i className="fa-solid fa-file-arrow-down"></i>
  <span>Generate</span>
</button>

{/* Add the Summary Modal Component at the bottom of the return */}
{isSummaryModalOpen && (
  <SummaryModal  
    onClose={() => setIsSummaryModalOpen(false)} 
    data={{
      address: "Etowah County, Alabama, United States",
      lotArea: "50,000 - 200,000 Sqft",
      created: "Nov 15 2023",
      status: "In Progress",
      reportType: "Land + Snow",
      features: reportFeatures['land+snow'],
      total: "$321.32"
    }}
  />
)}


  
  <button className="btn-action-outline">
    <i className="fa-solid fa-xmark"></i>
    <span>Cancel</span>
  </button>

  <button className="btn-action-outline">
    <i className="fa-solid fa-floppy-disk"></i>
    <span>Save</span>
  </button>
</div>



    </div>
  );
};

export default ProjectDetails;